import { render, staticRenderFns } from "./RuleCard.vue?vue&type=template&id=739a58a5&scoped=true&"
import script from "./RuleCard.vue?vue&type=script&lang=js&"
export * from "./RuleCard.vue?vue&type=script&lang=js&"
import style0 from "./RuleCard.vue?vue&type=style&index=0&id=739a58a5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739a58a5",
  null
  
)

export default component.exports